module.exports = __webpack_public_path__ + "img/calentadores_olc.560d813b.png";